import { FC, useState } from "react";
import CustomButton from "ui/Button";
import { ICON_NAMES } from "utils/constant";
import { useTranslation } from "react-i18next";
import CustomDropDownList from "ui/dropDown";
import { UserListFilter } from "api/user";

interface CustomProps {
  pageSize: number;
  setFilterOptions: (options: UserListFilter) => void;
  filterOptions: UserListFilter;
  exportAsPDF: () => void;
  exportAsExcel: () => void;
}
const Filter: FC<CustomProps> = ({
  setFilterOptions,
  filterOptions,
  exportAsPDF,
  ...props
}) => {
  const { t } = useTranslation();
  const [filter, setFilter] = useState<UserListFilter>();

  const applyFilter = (field: keyof UserListFilter) => {
    const trimmedValue = (filter?.[field] || "").toString().trim();
    if (trimmedValue === filterOptions[field]) {
      return;
    }
    setFilterOptions({
      ...filterOptions,
      [field]: trimmedValue,
      skip: 0,
    });
  };
  return (
    <div className="filter-container">
      <div className="filter-end-btn user-list-filter-end-btn">
        {/*<CustomButton*/}
        {/*	label={"PDF"}*/}
        {/*	onClick={() => exportAsPDF()}*/}
        {/*	iconName={ICON_NAMES.Download}*/}
        {/*/>*/}
        <CustomButton
          label={"Excel"}
          onClick={() => props.exportAsExcel()}
          iconName={ICON_NAMES.Download}
        />
      </div>
    </div>
  );
};

export default Filter;
